import { useEffect, useState } from "react";
import { toast } from "sonner";
import { sessionGet } from "../utils/sessionStore";
// import { Button } from "@/components/ui/button";

type PayrollRecord = {
  id: string;
  name: string;
  email: string;
  month: string;
  basicPay: number;
  netSalary: number;
  status?: string; 
};

const PayrollTable = () => {
  const [payrollRecords, setPayrollRecords] = useState<PayrollRecord[]>([]);
  // const [records, setRecords] = useState<PayrollRecord[]>([]);

  useEffect(() => {
    const fetchPayroll = async () => {
      try {
        const token = sessionGet("accessToken");
        const res = await fetch("/api/payroll-records", {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!res.ok) throw new Error("Failed to fetch payroll");

        const data = await res.json();
        setPayrollRecords(data.records || []);
      } catch (err) {
        console.error("Error fetching payroll:", err);
      }
    };

    fetchPayroll();
  }, []);
const handleProcessPayroll = async (id: string) => {
  try {
    const token = sessionGet("accessToken");
    const res = await fetch(`/api/process-payroll/${id}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (!res.ok) throw new Error("Failed to process payroll");

    setPayrollRecords((prev: PayrollRecord[]) =>
      prev.map((record: PayrollRecord) =>
        record.id === id ? { ...record, status: "processed" } : record
      )
    );

    toast.success("Payroll processed successfully!");
  } catch (err) {
    console.error("Error processing payroll:", err);
    toast.error("Error processing payroll.");
  }
};

  return (
    <div className="overflow-auto max-h-[70vh]">
      <table className="min-w-full table-auto border">
        <thead>
          <tr>
            <th className="sticky top-0 z-10 bg-gray-100 border px-4 py-2">Name</th>
            <th className="sticky top-0 z-10 bg-gray-100 border px-4 py-2">Email</th>
            <th className="sticky top-0 z-10 bg-gray-100 border px-4 py-2">Month</th>
            <th className="sticky top-0 z-10 bg-gray-100 border px-4 py-2">Basic Pay</th>
            <th className="sticky top-0 z-10 bg-gray-100 border px-4 py-2">Net Salary</th>
            <th className="sticky top-0 z-10 bg-gray-100 border px-4 py-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {payrollRecords.map((rec) => (
            <tr key={rec.id}>
              <td className="border px-4 py-2">{rec.name}</td>
              <td className="border px-4 py-2">{rec.email}</td>
              <td className="border px-4 py-2">{rec.month}</td>
              <td className="border px-4 py-2">₹{rec.basicPay.toFixed(2)}</td>
              <td className="border px-4 py-2">₹{rec.netSalary.toFixed(2)}</td>
              <td className="border p-2">
                <button
                  className="px-4 py-2 rounded bg-blue-500 text-white disabled:opacity-50"
                  onClick={() => handleProcessPayroll(rec.id)}
                  disabled={rec.status === "processed"}
                >
                  {rec.status === "processed" ? "Processed" : "Process"}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PayrollTable;
